export const baseConfig = {
  dsn: process.env.SENTRY_DSN,
  environment: process.env.NEXT_PUBLIC_ENV,
  // Or however deep you want your state context to be. useful for redux integration.
  normalizeDepth: 10,
  // Releases are global per organization; prefix them with something project-specific for easy differentiation.
  // This field should be same as the release tags in our VCS to allow sentry to access other features
  release: `${process.env.SENTRY_PROJECT}@${process.env.npm_package_version}`,
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 0.1,
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
};
